import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import messages from "../../../../../assets/locale/messages";
import VideoPlayer from "../../../../../components/VideoPlayer";

const VideoSection = ({ videoSrc, videoName }) => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    products: { productDetails }
  } = messages[lang];

  return (
    <div className="product-video-section mb-4 p-4 faint-grey-border border-radius-10">
      <h6 className="fsize-20 fweight-600 title-color mb-4">
        {productDetails.productVideo}
      </h6>
      <div className="border-radius-10">
        <VideoPlayer videoSrc={videoSrc} videoName={videoName} />
      </div>
    </div>
  );
};

export default VideoSection;

VideoSection.propTypes = {
  videoSrc: PropTypes.string.isRequired,
  videoName: PropTypes.string
};
